<template>
  <div class="flex_vh100 home">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar
        title="推广员审核"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
        <template #right>
          <van-icon
            name="filter-o"
            size="20"
            @click="showFilter = !showFilter"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="flex_vh100">
      <UniversalSearch
        v-show="showFilter"
        ref="universalSearch"
        title="筛选"
        :initial-form-data="formData"
        @search="handleSearch"
        @reset="handleReset"
      >
        <!-- 自定义搜索内容插槽 -->
        <template #search-content="{ formData }">
          <div class="search-fields">
            <div class="search-row">
              <div class="search-type">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="formData.state"
                    :options="searchStateList"
                    title="申请状态"
                  />
                </van-dropdown-menu>
              </div>
              <div class="search-input">
                <van-field
                  v-model="formData.mobile"
                  placeholder="手机号"
                  clearable
                />
              </div>
            </div>
          </div>
        </template>
      </UniversalSearch>

      <!-- 列表 -->
      <ListPage
        ref="listPage"
        :request-api="_getAgentApplyLog"
        :params="searchInfo"
        class="flex_vh100"
      >
        <template #default="{ list }">
          <div class="product-grid">
            <div v-for="item in list" :key="item.id" class="product-item">
              <van-cell-group>
                <van-cell>
                  <template #title>
                    <div class="card-title">
                      <span class="account-id"
                        >{{ item.accountId }}({{ item.number }})</span
                      >
                      <van-tag v-if="item.state == 1" type="primary"
                        >申请中</van-tag
                      >
                      <van-tag v-else-if="item.state == 2" type="danger"
                        >已拒绝</van-tag
                      >
                      <van-tag
                        v-else-if="item.state == 3 && !item.isAgent"
                        type="warning"
                        >等待开通</van-tag
                      >
                      <van-tag
                        v-else-if="item.state == 3 && item.isAgent"
                        type="success"
                        >已开通</van-tag
                      >
                    </div>
                  </template>
                  <template #label>
                    <div class="account-info">
                      <div v-if="item.mobile" class="info-item">
                        手机号: {{ item.mobile }}
                      </div>
                      <div
                        v-if="item.nickName || item.wc_nickName"
                        class="info-row"
                      >
                        <span v-if="item.nickName"
                          >昵称: {{ item.nickName }}</span
                        >
                        <span v-if="item.wc_nickName"
                          >微信: {{ item.wc_nickName }}</span
                        >
                      </div>
                    </div>
                  </template>
                </van-cell>
                <van-cell title="申请时间" :value="item.applyTime"></van-cell>
              </van-cell-group>
              <!-- 操作按钮 -->
              <div class="action-buttons">
                <van-button
                  v-if="item.state == 1"
                  type="primary"
                  size="small"
                  @click="handleApprove(item)"
                  >通过</van-button
                >
                <van-button
                  v-if="item.state == 1"
                  type="danger"
                  size="small"
                  @click="handleReject(item)"
                  >拒绝</van-button
                >
                <van-button
                  v-if="item.state == 3 && !item.isAgent"
                  type="warning"
                  size="small"
                  @click="handleSetAgent(item)"
                  >设置代理</van-button
                >
                <van-button
                  type="default"
                  size="small"
                  @click="handleDelete(item)"
                  >删除</van-button
                >
              </div>
            </div>
          </div>
        </template>
      </ListPage>
    </div>

    <!-- 审核弹窗 -->
    <van-popup
      v-model="showAuditDialog"
      position="bottom"
      round
      :style="{ height: '40%' }"
    >
      <div class="audit-dialog">
        <div class="audit-dialog-header">
          <span>{{ auditAction === "approve" ? "审核通过" : "审核拒绝" }}</span>
        </div>
        <div class="audit-dialog-body">
          <van-field
            v-model="auditRemark"
            type="textarea"
            placeholder="请输入审核备注"
            rows="4"
            autosize
          />
        </div>
        <div class="audit-dialog-footer">
          <van-button size="small" @click="showAuditDialog = false"
            >取消</van-button
          >
          <van-button size="small" type="primary" @click="confirmAudit"
            >确定</van-button
          >
        </div>
      </div>
    </van-popup>

    <!-- 设置代理组件 -->
    <AgentConfig ref="agentConfig" @saved="onAgentSaved" />
  </div>
</template>

<script>
import ListPage from "./controls/ListPage.vue";
import UniversalSearch from "./controls/UniversalSearch.vue";
import AgentConfig from "./controls/AgentConfig.vue";
import {
  GetAgentApplyLog,
  ModifyAgentApplyState,
  DeleteAgentApply,
} from "../api/financeapi.js";
export default {
  name: "AgentApply",
  components: { ListPage, UniversalSearch, AgentConfig },
  data() {
    const now = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    return {
      showFilter: false,
      isCollapsed: false, // 搜索区域是否收缩
      formData: {
        mobile: "",
        state: 0,
      },
      searchInfo: {
        mobile: "",
        state: 0,
      },

      searchStateList: [
        { value: 0, text: "全部" },
        { value: 1, text: "申请中" },
        { value: 2, text: "已拒绝" },
        { value: 3, text: "等待开通" },
        { valueid: 4, text: "已开通" },
      ],

      // 审核弹窗
      showAuditDialog: false,
      auditAction: "", // 'approve' 或 'reject'
      auditItem: null, // 当前审核的项
      auditRemark: "", // 审核备注
    };
  },
  watch: {
    showFilter(val) {
      if (this.$refs.universalSearch) {
        val ? this.$refs.universalSearch.expand() : this.$refs.universalSearch.collapse();
      }
    },
    $route(to) {
      // 路由变化时更新激活的标签
      if (to.name == "AgentApply") {
      }
    },
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1); // 后退一步
    },
    // 执行搜索
    handleSearch(searchParams) {
      this.searchInfo = searchParams;
    },

    // 重置搜索条件
    handleReset() {
      this.formData = {
        mobile: "",
        state: 0,
      };
    },

    // 审批通过
    handleApprove(item) {
      this.auditAction = "approve";
      this.auditItem = item;
      this.auditRemark = "";
      this.showAuditDialog = true;
    },

    // 审批拒绝
    handleReject(item) {
      this.auditAction = "reject";
      this.auditItem = item;
      this.auditRemark = "";
      this.showAuditDialog = true;
    },

    // 确认审核
    confirmAudit() {
      const state = this.auditAction === "approve" ? 3 : 2;
      const params = {
        id: this.auditItem.id,
        state: state,
        stateDes: this.auditRemark,
      };
      this._modifyAgentApplyState(params).then((res) => {
        this.$toast.success(
          this.auditAction === "approve" ? "审核通过" : "已拒绝"
        );
        this.showAuditDialog = false;
        this.$refs.listPage.refresh(); // 刷新列表
      });
    },

    // 设置代理
    handleSetAgent(item) {
      this.$refs.agentConfig.open(null, item.accountId);
    },

    // 设置代理保存成功回调
    onAgentSaved() {
      this.$refs.listPage.refresh();
    },

    // 删除代理申请
    handleDelete(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要删除该代理申请吗？",
        })
        .then(() => {
          this._deleteAgentApply(item.id).then(() => {
            this.$toast.success("删除成功");
            this.$refs.listPage.refresh();
          });
        })
        .catch(() => {});
    },

    // 查询代理申请列表
    _getAgentApplyLog(params) {
      return GetAgentApplyLog(params);
    },

    // 代理申请通过/拒绝
    _modifyAgentApplyState(params) {
      return ModifyAgentApplyState(params);
    },

    // 删除代理申请
    _deleteAgentApply(id) {
      var par = {
        Id: id,
      };
      return DeleteAgentApply(par);
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 隐藏 UniversalSearch 自带的 header，切换按钮已在导航栏 */
:deep(.collapsible-search .search-header) {
  display: none;
}

.search-fields {
  display: flex;
  flex-direction: column;
}

.search-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-type {
  flex-shrink: 0;
  width: 110px;
}

.search-type :deep(.van-dropdown-menu__bar) {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: none;
  height: 36px;
  border: 1px solid #ebedf0;
}

.search-type :deep(.van-dropdown-menu__title) {
  padding: 0 10px;
  line-height: 34px;
  font-size: 13px;
}

.search-input {
  flex: 1;
}

.search-input :deep(.van-field) {
  background-color: #fff;
  border-radius: 6px;
  padding: 6px 10px;
  border: 1px solid #ebedf0;
}

.search-input :deep(.van-field__control) {
  font-size: 13px;
}

.product-item {
  background-color: #fff;
  border-bottom: 1px solid #f5f6f8;
  margin-bottom: 10px;
}
.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.account-id {
  font-size: 15px;
  font-weight: 500;
  color: #323233;
}
.account-info {
  font-size: 13px;
  color: #969799;
}
.info-item {
  margin-bottom: 2px;
}
.info-row {
  display: flex;
  gap: 12px;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 14px;
  background: #fff;
}

.action-buttons :deep(.van-button) {
  min-width: 64px;
  height: 28px;
  font-size: 12px;
  border-radius: 4px;
  padding: 0 12px;
}
.audit-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
}
.audit-dialog-header {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding-bottom: 12px;
}
.audit-dialog-body {
  flex: 1;
}
.audit-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
}
</style>